<template>
  <b-container v-if="verified">
    <Loading v-if="isLoading" :active.sync="isLoading"></Loading>
    <b-card class="page-body" body-class="has-footer">
      <CRow>
        <CCol xm="12" class="d-flex justify-content-center mb-4">
          <img class="header-img" src="../../assets/images/logo-indocyber.png">
        </CCol>
      </CRow>
      <CRow>
        <CCol xm="12" class="d-flex justify-content-center my-2">
          <h1 class="page-greetings">
            OCR Kad Malaysia
          </h1>
        </CCol>
      </CRow>
      <CRow>
        <CCol class="col-12 col-md-6 align-self-center media-container-overlay">
          <div class="col-12 mb-5">
            <label v-if="showPreview" class="textarea-input">Preview Image:</label>
            <canvas v-show="showPreview && currCanvas == 'preview'" id="cvs-preview" class="preview-annotate mb2"></canvas>
            <canvas v-show="showPreview && currCanvas == 'annotate'" id="cvs-annotate" class="preview-annotate mb2"></canvas>
            <!-- <b-img v-if="showPreview" :src="imagePreview" class="preview-canvas mb-2"></b-img> -->
            <label class="textarea-input" v-if="showPreviewWebcam && webcamPhoto != null">{{ webcamLabel }}</label>
            <canvas id="webcam-preview" v-show="showPreviewWebcam && currCanvas == 'preview'" ref="wbc-preview" class="preview-annotate mb2"></canvas>
            <canvas id="webcam-annotate" v-show="showPreviewWebcam && currCanvas == 'annotate'" ref="wbc-annotate" class="preview-annotate mb2"></canvas>
          </div>
          <div v-if="hasRearCamera" v-show="!showPreview" class="media-wrapper">
            <!-- <img v-show="webcamPhoto != null" :src="webcamPhotoPreview"> -->
            <canvas id="overlay" v-show="webcamPhoto == null && kadType != 'birth_certificate'" ref="overlay" class="video-overlay" :width="canvasSize.width" :height="canvasSize.height"></canvas>
            <canvas id="overlay-cert" v-show="webcamPhoto == null && kadType == 'birth_certificate'" ref="overlaycert" class="video-overlay" :width="canvasSize.width" :height="canvasSize.height"></canvas>
            <!-- <video autoplay ref="video" v-show="webcamPhoto == null" id="video">Webcam not available.</video> -->
            <video autoplay muted playsinline ref="video" v-show="webcamPhoto == null" id="video">Webcam not available.</video>
            <!-- <canvas id="canvas-crop" ref="canvascrop" v-show="false" class="w-100" :width="cropSize.width" :height="cropSize.height"></canvas> -->
            <canvas id="canvas-crop" ref="canvascrop" v-show="false" :width="canvasSize.width" :height="canvasSize.height"></canvas>
            <canvas id="canvas" ref="canvas" v-show="false" :width="canvasSize.width" :height="canvasSize.height"></canvas>
          </div>
          <div class="form-button align-center mt-4">
            <router-link v-if="showPreview" :to="{}" @click.native="onClickClear" class="btn">
              <span><img src=""></span>Clear Uploaded Image
            </router-link>
            <router-link v-else-if="webcamPhoto == null && hasRearCamera" :to="{}" @click.native="onClickWebcam" class="btn" :class="isWebcamReady ? '' : 'disabled'">
              <span><img src=""></span>Take Webcam Photo
            </router-link>
            <router-link v-else-if="hasRearCamera" :to="{}" @click.native="onClickClear" class="btn danger">
              <span><img src=""></span>Discard and Take New Photo
            </router-link>
          </div>
        </CCol>
      </CRow>
      <div class="content">
        <CRow>
          <div class="col-12">
            <label class="textarea-input">Input Image:</label>
            <input :disabled="webcamPhoto != null" ref="fileupload" class="mb-1 sm-input" type="file" accept="image/png, image/jpeg" @change="onChooseImage">
            <b-form inline class="form-options mb-1">
              <label for="kad-type" class="mr-2">Card Type: </label>
              <b-form-select v-model="kadType" id="kad-type" @change="onChangeKadType">
                <b-form-select-option value="mykad">MyKad</b-form-select-option>
                <b-form-select-option value="mykas">MyKAS</b-form-select-option>
                <b-form-select-option value="mypr">MyPR</b-form-select-option>
                <b-form-select-option value="mykid">MyKID</b-form-select-option>
                <b-form-select-option value="driving_licence">Driving License</b-form-select-option>
                <b-form-select-option value="birth_certificate">Birth Certificate</b-form-select-option>
              </b-form-select>
            </b-form>
            <b-form inline class="form-options mb-4">
              <label for="kad-face" class="mr-2">Card Face: </label>
              <b-form-select :disabled="kadType == 'birth_certificate'" v-model="kadFace" id="kad-face">
                <b-form-select-option value="front">Front</b-form-select-option>
                <b-form-select-option value="back">Back</b-form-select-option>
              </b-form-select>
            </b-form>
          </div>
          <CCol col="12" class="form-button">
            <div class="sm-nav-wrapper">
              <div class="bottom-router">
                <router-link :to="{}" @click.native="onClickSubmit" class="btn">
                  <span><img src=""></span>Submit
                </router-link>
              </div>
            </div>
          </CCol>
        </CRow>
      </div>
      <CRow v-if="keywords.length > 0">
        <CCol xm="12" class="d-flex justify-content-center my-2">
          <h4 class="greetings-underline">
            RESPONSE DATA
          </h4>
        </CCol>
      </CRow>
      <div v-if="keywords.length > 0" class="content">
        <CRow>
          <div class="col-12">
            <b-table small
              :fields="fields"
              :items="keywords"
            >
              <template #cell(index)="row">
                {{ row.index + 1 }}
              </template>
            </b-table>
          </div>
        </CRow>
      </div>
      <TheFooter></TheFooter>
    </b-card>
      <Modal v-if="showErrorModal" :foreground="true" :closeButton="false">
        <div slot="body">
          <label>{{errorLabel}}</label>
          <div class="btn-footer">
            <button class="btn-submit white" @click="showErrorModal = false">
              Tutup
            </button>
          </div>
        </div>
      </Modal>
  </b-container>
</template>
<script>
import TheFooter from  '../TheFooter'
import Modal from  '../Modal'

export default {
  name: 'Main',
  components: {
    TheFooter,
    Modal
  },
  data(){
    return {
      verified: false,
      isLoading: false,
      showErrorModal: false,
      errorLabel: "Terjadi kesalahan pada server. Silahkan coba lagi.",
      errorReload: false,
      fields: [
          { key: 'label', label: 'Label' },
          { key: 'value', label: 'Value' },
          { key: 'confidence', label: 'Confidence' },
      ],
      kadType: "mykad",
      prevKadType: "mykad",
      kadFace: "front",
      optionsEnum: {
        mykad: "MyKad",
        mykas: "MyKAS",
        mypr: "MyPR",
        mykid: "MyKID",
        driving_licence: "Driving License",
        birth_certificate: "Birth Certificate",
        front: "Front",
        back: "Back"
      },
      base64: "",
      keywords: [],
      boxes: [],
      imagePreview: null,
      showPreview: false,
      showPreviewWebcam: false,
      currCanvas: 'preview',
      file: null,
      isWebcamReady: false,
      webcamPhoto: null,
      // webcamPhotoPreview: require("../../assets/images/profile-blank.webp"),
      webcamPhotoPreview: "",
      hasRearCamera: true,
      canvasSize: {
        width: 0,
        height: 0
      },
      videoSize: {
        width: 0,
        height: 0
      },
      cropSize: {
        x:0,
        y:0,
        width:0, 
        height:0,
      },
      cropSizeCard: {
        x:0,
        y:0,
        width:0, 
        height:0,
      },
      cropSizeCert: {
        x:0,
        y:0,
        width:0, 
        height:0,
      },
    }
  },
  computed: {
    webcamLabel() {
      if(this.kadType == "birth_certificate"){
        return `${this.optionsEnum[this.kadType]} - Front`
      }
      else{
        return `${this.optionsEnum[this.kadType]} - ${this.optionsEnum[this.kadFace]}`
      }
    }
  },
  methods: {
    onChangeKadType(){
      if(this.kadType == 'birth_certificate'){
        this.cropSize.x = this.cropSizeCert.x
        this.cropSize.y = this.cropSizeCert.y
        this.cropSize.width = this.cropSizeCert.width
        this.cropSize.height = this.cropSizeCert.height
        this.kadFace = "front"
      }
      else{
        this.cropSize.x = this.cropSizeCard.x
        this.cropSize.y = this.cropSizeCard.y
        this.cropSize.width = this.cropSizeCard.width
        this.cropSize.height = this.cropSizeCard.height
      }
      if(this.webcamPhoto != null){
        if(this.prevKadType == "birth_certificate" || this.kadType == "birth_certificate"){
          this.onClickClear()
          this.prevKadType = this.kadType
          this.$forceUpdate()
        }
      }
    },
    onClickClear(){
      this.keywords = []
      this.file = null
      this.imagePreview = null
      const cvs = document.getElementById('cvs-preview')
      const ctx = cvs.getContext('2d')
      const cvs2 = document.getElementById('cvs-annotate')
      const ctx2 = cvs2.getContext('2d')
      ctx.clearRect(0, 0, cvs.width, cvs.height)
      ctx2.clearRect(0, 0, cvs.width, cvs.height)
      this.base64 = ""
      this.webcamPhoto = null
      this.$refs.fileupload.value = null
      this.currCanvas = 'preview'
      this.showPreview = false
      this.showPreviewWebcam = false
    },
    onClickWebcam(){

      const context = this.$refs.canvascrop.getContext('2d')
      // context.drawImage(this.$refs.video, this.cropSize.x, this.cropSize.y, this.cropSize.width, this.cropSize.height, 0, 0, this.cropSize.width, this.cropSize.height)
      context.drawImage(this.$refs.video, 0, 0, this.canvasSize.width, this.canvasSize.height)
      document.getElementById("canvas-crop").toBlob((blob) => {
        let file = new File([blob], "webcam-preview.jpg", { type: "image/jpeg" })
        this.webcamPhotoPreview = URL.createObjectURL(file)
        this.webcamPhoto = file
        const cvs = document.getElementById('webcam-preview')
        const ctx = cvs.getContext('2d')
        const cvs2 = document.getElementById('webcam-annotate')
        const ctx2 = cvs2.getContext('2d')
        const img = new Image
        img.src = URL.createObjectURL(file)
        img.onload = function() {
          cvs.width = img.width
          cvs.height = img.height
          ctx.drawImage(img, 0, 0)
          cvs2.width = img.width
          cvs2.height = img.height
          ctx2.drawImage(img, 0, 0)
        }
        this.currCanvas = 'preview'
        this.showPreviewWebcam = true
        var reader = new FileReader()
        reader.readAsDataURL(this.webcamPhoto)
        let vm = this
        reader.onload = function () {
          vm.base64 = reader.result.split(",")[1]
        }
      }, 'image/jpeg')
    },
    onChooseImage(e){
      this.keywords = []
      const file = e.target.files[0]
      if(file){
        this.file = e.target.files[0]
        this.imagePreview = URL.createObjectURL(file)
        this.createBase64Image(file)
        // this.imagePreview = URL.createObjectURL(file)
        const cvs = document.getElementById('cvs-preview')
        const ctx = cvs.getContext('2d')
        const cvs2 = document.getElementById('cvs-annotate')
        const ctx2 = cvs2.getContext('2d')
        ctx.clearRect(0, 0, cvs.width, cvs.height)
        ctx2.clearRect(0, 0, cvs.width, cvs.height)
        const img = new Image
        img.src = URL.createObjectURL(e.target.files[0])
        img.onload = function() {
          cvs.width = img.width
          cvs.height = img.height
          ctx.drawImage(img, 0, 0)
          cvs2.width = img.width
          cvs2.height = img.height
          ctx2.drawImage(img, 0, 0)
        }
        // this.createBase64Image(file)
        this.currCanvas = 'preview'
        this.showPreview = true
      }
    },
    createBase64Image(FileObject) {
      const reader = new FileReader()
      reader.onloadend = () => {
        this.base64 = reader.result.split(",")[1]
      }
      reader.readAsDataURL(FileObject)
    },
    drawAnnotateBox() {
      const cvs = document.getElementById("cvs-annotate")
      const ctx = cvs.getContext("2d")
      ctx.strokeStyle = "red"
      ctx.lineWidth = parseInt(cvs.width/500) + 1
      ctx.beginPath()
      for(let box of this.boxes){
        ctx.beginPath()
        ctx.moveTo(box.coordinate[0][0], box.coordinate[0][1])
        ctx.lineTo(box.coordinate[1][0], box.coordinate[1][1])
        ctx.lineTo(box.coordinate[2][0], box.coordinate[2][1])
        ctx.lineTo(box.coordinate[3][0], box.coordinate[3][1])
        ctx.closePath()
        ctx.stroke()
      }
    },
    drawAnnotateBoxWebcam() {
      const cvs = document.getElementById("webcam-annotate")
      const ctx = cvs.getContext("2d")
      ctx.strokeStyle = "red"
      ctx.lineWidth = parseInt(cvs.width/500) + 1
      ctx.beginPath()
      for(let box of this.boxes){
        ctx.beginPath()
        ctx.moveTo(box.coordinate[0][0], box.coordinate[0][1])
        ctx.lineTo(box.coordinate[1][0], box.coordinate[1][1])
        ctx.lineTo(box.coordinate[2][0], box.coordinate[2][1])
        ctx.lineTo(box.coordinate[3][0], box.coordinate[3][1])
        ctx.closePath()
        ctx.stroke()
      }
    },
    onClickSubmit(){
      this.isLoading = true
      // let processUrl = "https://ktp.ocr.dev.inergi.id/api-ktp/document_classifier"
      // let processUrl = `http://194.233.64.26:9021/${this.kadType}`
      let processUrl = `https://validation.demo.inergi.id/api/api-mykad/${this.kadType}`
      let data = {
        "key": "d88a5b1144137cd939a0cc6d43b75dfd",
        "view_type": this.kadFace,
        "image": this.base64
      }
      // let data = new FormData()
      // data.set('officeCode', this.selectedOffice.officeCode)
      this.$axios.post(processUrl, data).then((response) => {

        if (response.status === 200){

          if(!response.data.success){
            this.errorLabel = response.data.message
            this.errorReload = false
            this.showErrorModal = true
            return
          }

          let raw = response.data.data
          let entries = []
          for (const [key, value] of Object.entries(raw)){
            entries.push({label: key, value: value.value, confidence: value.confidence})
          }
          this.keywords = entries
          this.boxes = response.data.data_raw
          this.drawAnnotateBox()
          if(this.hasRearCamera) this.drawAnnotateBoxWebcam()
          this.currCanvas = 'annotate'
        }
        else {
          this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
          this.errorReload = false
          this.showErrorModal = true
          return
        }
      })
      .catch(error => {
        if(error.response){
          if(error.response.status == "401"){
            this.errorLabel = "API Key tidak valid atau sudah tidak berlaku. Mohon menghubungi tim untuk kode akses baru."
            this.$cookies.remove("api-key-mykad")
            delete this.$axios.defaults.headers.post['API-Key']
          }
          else{
            if(error.response.data && error.response.data.reason) this.errorLabel = error.response.data.reason
            else this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
          }
        }
        else this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
        this.errorReload = false
        this.showErrorModal = true
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    isDesktop(a) {
      let check = true
      if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))){
        check = false
      }
      return check
    }
  },
  async mounted(){

    // this.$axios.defaults.headers.post['Content-Type'] = 'application/json';
    // this.$axios.post(processUrl, data, { headers: {"Content-Type": "multipart/form-data"} }).then((response) => {
    let res = ""
    if(this.$cookies.get("api-key-mykad")){
      res = this.$cookies.get("api-key-mykad")
      this.verified = true
    }
    else{
      while(!res) res = window.prompt("Please enter your access key.", "")
      while(!this.verified){
        await this.$axios.post("https://validation.demo.inergi.id/api/auth/validate-key", null, { headers: {"API-Key": res} }).then(_ => {
          this.$cookies.set("api-key-mykad", res)
          this.$axios.defaults.headers.post['API-Key'] = res
          this.$axios.defaults.headers.get['API-Key'] = res
          this.verified = true
        })
        .catch(error => {
          if(error.response){
            if(error.response.status == "401"){
              res = ""
              while(!res) res = window.prompt("Key validation failed. Please enter your access key.", "")
            }
            else{
              res = ""
              while(!res) res = window.prompt("Network error during verification. Please enter your access key.", "")
            }
          }
          else{
            res = ""
            while(!res) res = window.prompt("Network error during verification. Please enter your access key.", "")
          }
        })
      }
    }
    
    this.isLoading = true

    // quick workaround so the video component can load first
    await new Promise(r => setTimeout(r, 200));

    let vm = this

    let video = document.getElementById("video")

    let constraints = {
      audio: false,
      video: { 
        width: {ideal: 99999}, 
        height: {ideal: 99999},
        // facingMode: { ideal: "environment" }
        facingMode: { exact: "environment" }
      },
    }

    navigator.mediaDevices
      .getUserMedia(constraints)
      .then((stream) => {
        var settings = stream.getVideoTracks()[0].getSettings()
        this.getPrepWidth = settings.width
        this.getPrepHeight = settings.height
        stream.getTracks().forEach(track => track.stop())

        constraints = {
          audio: false,
          video: {
            width: {ideal: this.getPrepWidth}, 
            height: {ideal: this.getPrepHeight},
            // facingMode: { ideal: "environment" }
            facingMode: { exact: "environment" }
          },
        }
        
        navigator.mediaDevices
          .getUserMedia(constraints)
          .catch(error => {
            this.hasRearCamera = false
            this.isLoading = false
          })
          .then((stream) => {
            var settings = stream.getVideoTracks()[0].getSettings()
            this.videoSize.width = settings.width
            this.videoSize.height = settings.height
            this.canvasSize.width = settings.width
            this.canvasSize.height = settings.height
            video.srcObject = stream
            this.isWebcamReady = true
            return new Promise(resolve => video.onloadedmetadata = resolve)
          })
          .then(() => {
            this.videoSize.width = document.querySelector("#video").videoWidth
            this.videoSize.height = document.querySelector("#video").videoHeight
            this.canvasSize.width = document.querySelector("#video").videoWidth
            this.canvasSize.height = document.querySelector("#video").videoHeight
            this.$nextTick(() => {
              if(this.isDesktop(navigator.userAgent||navigator.vendor||window.opera)){
                this.hasRearCamera = false
              }
              const overlay = this.$refs.overlay.getContext('2d')
              overlay.rect(0,0,this.canvasSize.width,this.canvasSize.height)
              overlay.fillStyle = "rgba(0, 0, 0, 0.7)"
              overlay.fill()
              let relativeWidth = this.canvasSize.width * 0.98
              let relativeHeight = relativeWidth * 5.5 / 9
              if(relativeHeight > this.canvasSize.height * 0.98){
                relativeHeight = this.canvasSize.height * 0.98
                relativeWidth = relativeHeight * 9 / 5.5
              }
              let params = {
                lineWidth: (this.canvasSize.width / 100) + 1,
                x: (this.canvasSize.width - relativeWidth) / 2,
                y: (this.canvasSize.height - relativeHeight) / 2,
                width: relativeWidth,
                height: relativeHeight,
                radius: this.canvasSize.width / 100
              }
              let originalWidth = this.videoSize.width * 0.98
              let originalHeight = originalWidth * 5.5 / 9
              if(originalHeight > this.videoSize.height * 0.98){
                originalHeight = this.videoSize.height * 0.98
                originalWidth = originalHeight * 9 / 5.5
              }
              this.cropSizeCard.x = (this.videoSize.width - originalWidth) / 2
              this.cropSizeCard.y = (this.videoSize.height - originalHeight) / 2
              this.cropSizeCard.width = originalWidth
              this.cropSizeCard.height = originalHeight
              this.cropSize.x = this.cropSizeCard.x
              this.cropSize.y = this.cropSizeCard.y
              this.cropSize.width = this.cropSizeCard.width
              this.cropSize.height = this.cropSizeCard.height
              overlay.lineWidth = params.lineWidth
              overlay.strokeStyle = "orange"
              overlay.beginPath()
              overlay.roundRect(params.x, params.y, params.width, params.height, params.radius)
              overlay.clip()
              overlay.clearRect(params.x, params.y, params.width, params.height)
              overlay.restore()
              overlay.fillStyle = "rgba(255, 255, 255, 0)"
              overlay.fill()
              overlay.stroke()

              const overlaycert = this.$refs.overlaycert.getContext('2d')
              overlaycert.rect(0,0,this.canvasSize.width,this.canvasSize.height)
              overlaycert.fillStyle = "rgba(0, 0, 0, 0.7)"
              overlaycert.fill()
              let relativeHeightCert = this.canvasSize.height * 0.98
              let relativeWidthCert = relativeHeightCert * 27 / 40
              if(relativeWidthCert > this.canvasSize.width * 0.98){
                relativeWidthCert = this.canvasSize.width * 0.98
                relativeHeightCert = relativeWidthCert * 40 / 27
              }
              let paramscert = {
                lineWidth: (this.canvasSize.width / 100) + 1,
                x: (this.canvasSize.width - relativeWidthCert) / 2,
                y: (this.canvasSize.height - relativeHeightCert) / 2,
                width: relativeWidthCert,
                height: relativeHeightCert,
                radius: this.canvasSize.width / 100
              }
              let originalHeightCert = this.videoSize.height * 0.98
              let originalWidthCert = originalHeightCert * 27 / 40
              if(originalWidthCert > this.videoSize.width * 0.98){
                originalWidthCert = this.videoSize.width * 0.98
                originalHeightCert = originalWidthCert * 40 / 27
              }
              this.cropSizeCert.x = (this.videoSize.width - originalWidthCert) / 2
              this.cropSizeCert.y = (this.videoSize.height - originalHeightCert) / 2
              this.cropSizeCert.width = originalWidthCert
              this.cropSizeCert.height = originalHeightCert
              overlaycert.lineWidth = paramscert.lineWidth
              overlaycert.strokeStyle = "orange"
              overlaycert.beginPath()
              overlaycert.roundRect(paramscert.x, paramscert.y, paramscert.width, paramscert.height, paramscert.radius)
              overlaycert.clip()
              overlaycert.clearRect(paramscert.x, paramscert.y, paramscert.width, paramscert.height)
              overlaycert.restore()
              overlaycert.fillStyle = "rgba(255, 255, 255, 0)"
              overlaycert.fill()
              overlaycert.stroke()
            })
          })
          .finally(() => {
            this.isLoading = false
          })
      })
      .catch(error => {
        this.hasRearCamera = false
        this.isLoading = false
      })
      
  }
}
</script>